import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';


const Drp_Brand = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState(-1);
    const Brand_Onchange = (value) => {
        props.onChange(value == null ? -1 : value, value == null ? "" : List.find(x => x.Id == value).Title)
        setId(value)
    }
    useImperativeHandle(ref, () => ({

        BindBrand(id) {
            var MyHeader = new Headers();
            MyHeader.append("ApiKey", General.APIKey());
            MyHeader.append("IsActive", 1);
            MyHeader.append("WebIsActive", -1);

            var requestOption = {
                headers: MyHeader,
                method: "Get",
                credentials: 'include'
            }
            trackPromise(
                fetch(General.ApiRoute() + "/ProductBrand/GetAll", requestOption)
                    .then(Response => Response.json())
                    .then(result => {
                        var lists = [];
                        for (var i = 0; i < result.length; i++) {
                            lists.push({
                                Title: result[i].title,
                                Id: result[i].id
                            })
                            if (result[i].id == id) {
                                props.onChange(id, result[i].title)
                            }
                        }
                        setList(lists)
                        setId(id)

                    })
            )


        },

    }))



    return (
        <rsuite.SelectPicker


            data={List}
            valueKey="Id"
            labelKey="Title"
            className='w-100p'
            placeholder="انتخاب کنید..."
            value={Id}
            onChange={(value) => Brand_Onchange(value)}

        />

        // <>
        //     <select className={props.className} onChange={Brand_Onchange} value={props.value}>
        //         <option value="-1">انتخاب نمایید</option>
        //         {
        //             List.map(item => (
        //                 <option value={item.Id}> {item.Title}  </option>
        //             ))
        //         }

        //     </select>
        // </>
    )
});

export default Drp_Brand;